import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const UpdatePushToken = gql`
  mutation UpdatePushToken(
    $idempotencyId: IdempotencyToken!
    $input: UpdatePushTokenInput!
  ) {
    updatePushToken(idempotencyId: $idempotencyId, input: $input) {
      __typename
      ... on UpdatePushTokenSuccess {
        id
      }
      ... on UpdatePushTokenError {
        ...error
      }
    }
  }
  ${error}
`;
